import ads from "./logic/ads.js"
import words from "./logic/words.js"

export default {

  threadsCount: 4,
  minimalSetSizeForThreading: 5000,

  defaultFilter: {
    "type": "and",
    args: [
      {
        "type": "and",
        args: [
          {
            "type": "or",
            args: [
              {
                "type": ">",
                "args": ["Count", 100]
              }
            ]
          }
        ]
      }
    ]
  },

  categoryColumns: ['CampaignName', 'AdGroupName'],

  ads,
  words
}



// WEBPACK FOOTER //
// ./src/config/logic.js